"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseRequestServiceImpl = void 0;
const rxjs_1 = require("rxjs");
const core_1 = require("@athena-portal/core");
const ajax_1 = require("rxjs/ajax");
const operators_1 = require("rxjs/operators");
const Types_1 = require("../../Types");
/**
 * Rest implementation of the example service
 */
let BaseRequestServiceImpl = class BaseRequestServiceImpl {
    constructor(notificationService) {
        this.notificationService = notificationService;
    }
    getDocumentSize(documentPath) {
        return (0, ajax_1.ajax)({
            method: "HEAD",
            url: documentPath,
        }).pipe((0, operators_1.map)((response) => {
            return response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "Failed to fetch document size on path: " + documentPath
            });
            return (0, rxjs_1.throwError)(err);
        }));
    }
};
exports.BaseRequestServiceImpl = BaseRequestServiceImpl;
exports.BaseRequestServiceImpl = BaseRequestServiceImpl = __decorate([
    (0, core_1.injectable)(),
    __param(0, (0, core_1.inject)(Types_1.Types.NotificationService)),
    __metadata("design:paramtypes", [Object])
], BaseRequestServiceImpl);
//# sourceMappingURL=BaseRequestServiceImpl.js.map